import type React from "react";
import Lottie from "react-lottie";

interface AnimatedImgProps {
  src: any;
}

const AnimatedImg: React.FC<AnimatedImgProps> = ({ src }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: src,
  };

  return (
    <div data-cy="lottie-animated-img">
      <Lottie options={defaultOptions} />
    </div>
  );
};

export default AnimatedImg;
